/*
 * RE:VOIR — Fiche produit (sections/product-revoir.liquid)
 * Onglets, quantité, vidéo, galerie, encarts, ajout au panier sans quitter la page.
 * Avant l'étape 2, ce code était écrit dans la page (20 Ko par fiche, jamais mis en cache).
 * Chargé en différé : il s'exécute une fois la page lue, avant DOMContentLoaded.
 */
(function() {
  'use strict';

  var defaultTabTitle = (window.rvProductStrings && window.rvProductStrings.defaultTabTitle) || 'Détails';

  /* ─── PARSING ONGLETS ─── */
  function initTabs() {
    var source = document.getElementById('pc-description-source');
    if (!source) return;
    var html = source.innerHTML.trim();
    if (!html) return;

    var parser = new DOMParser();
    var doc = parser.parseFromString('<div>' + html + '</div>', 'text/html');
    var container = doc.body.firstChild;

    var tabs = [];
    var currentTab = { title: defaultTabTitle, content: '' };
    var children = container.childNodes;

    for (var i = 0; i < children.length; i++) {
      var node = children[i];
      if (node.nodeType === 1 && node.tagName === 'H4') {
        if (currentTab.content.trim()) tabs.push(currentTab);
        currentTab = { title: node.textContent.trim(), content: '' };
      } else if (node.nodeType === 1) {
        currentTab.content += node.outerHTML;
      } else if (node.nodeType === 3 && node.textContent.trim()) {
        currentTab.content += '<p>' + node.textContent.trim() + '</p>';
      }
    }
    if (currentTab.content.trim()) tabs.push(currentTab);
    if (tabs.length === 0) return;

    var descIdx = -1;
    for (var d = 0; d < tabs.length; d++) {
      var t = tabs[d].title.toLowerCase();
      if (t === 'description') { descIdx = d; break; }
    }
    if (descIdx > 0) {
      var descTab = tabs.splice(descIdx, 1)[0];
      tabs.unshift(descTab);
    }

    var packSource = document.getElementById('pc-pack-content');
    if (packSource) {
      var packLabel = document.documentElement.lang === 'fr' ? 'Contenu' : 'Content';
      tabs.push({ title: packLabel, content: packSource.innerHTML });
    }

    var tabsBar = document.getElementById('pc-tabs-bar');
    var tabPanels = document.getElementById('pc-tab-panels');
    if (!tabsBar || !tabPanels) return;

    tabsBar.innerHTML = '';
    tabPanels.innerHTML = '';

    tabs.forEach(function(tab, idx) {
      var btn = document.createElement('button');
      btn.className = 'pc-tab-btn' + (idx === 0 ? ' is-active' : '');
      btn.setAttribute('data-tab-index', idx);
      btn.setAttribute('type', 'button');
      btn.textContent = tab.title;
      tabsBar.appendChild(btn);

      var panel = document.createElement('div');
      var isDesc = tab.title.trim().toLowerCase() === 'description';
      panel.className = 'pc-tab-panel' + (idx === 0 ? ' is-active' : '') + (isDesc ? ' is-description' : '');
      panel.setAttribute('data-panel-index', idx);
      panel.innerHTML = tab.content;
      tabPanels.appendChild(panel);
    });

    tabsBar.addEventListener('click', function(e) {
      var btn = e.target.closest('.pc-tab-btn');
      if (!btn) return;
      var idx = btn.getAttribute('data-tab-index');
      tabsBar.querySelectorAll('.pc-tab-btn').forEach(function(b) { b.classList.remove('is-active'); });
      tabPanels.querySelectorAll('.pc-tab-panel').forEach(function(p) { p.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var t = tabPanels.querySelector('[data-panel-index="' + idx + '"]');
      if (t) t.classList.add('is-active');
    });
  }

  /* ─── VARIANTES + QUANTITÉ + PRIX (avec gestion promo) ─── */
  function initBuyControls() {
    var radios = document.querySelectorAll('.pc-variant-radio');
    var priceEl = document.querySelector('[data-buy-price]');
    var qtyInput = document.getElementById('pc-quantity');
    var minusBtn = document.querySelector('[data-qty-minus]');
    var plusBtn = document.querySelector('[data-qty-plus]');

    if (!priceEl || !qtyInput) return;

    function formatMoney(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function updatePrice() {
      var unitPrice = parseInt(priceEl.getAttribute('data-unit-price'), 10);
      var isPromo = priceEl.getAttribute('data-is-promo') === 'true';
      var promoPercent = parseInt(priceEl.getAttribute('data-promo-percent'), 10) || 0;
      var qty = parseInt(qtyInput.value, 10) || 1;

      if (isPromo && promoPercent > 0) {
        var salePrice = Math.round(unitPrice * (100 - promoPercent) / 100);
        priceEl.innerHTML =
          '<span class="pc-price-compare">' + formatMoney(unitPrice * qty) + '</span>' +
          '<span class="pc-price-sale">' + formatMoney(salePrice * qty) + '</span>';
      } else {
        priceEl.textContent = formatMoney(unitPrice * qty);
      }
    }

    function updateImage(radio) {
      var img = document.getElementById('pc-product-image');
      if (!img) return;
      var variantImage = radio.getAttribute('data-variant-image');
      var variantAlt = radio.getAttribute('data-variant-image-alt');
      if (variantImage) {
        img.src = variantImage;
        if (variantAlt) img.alt = variantAlt;
      } else {
        img.src = img.getAttribute('data-default-src');
        img.alt = img.getAttribute('data-default-alt');
      }
    }

    var notice = document.getElementById('pc-variant-notice');

    function updateNotice(radio) {
      if (!notice) return;
      notice.hidden = radio.getAttribute('data-variant-notice') !== '1';
    }

    radios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        priceEl.setAttribute('data-unit-price', this.getAttribute('data-variant-price'));
        document.querySelectorAll('.pc-variant-option').forEach(function(o) { o.classList.remove('is-active'); });
        this.closest('.pc-variant-option').classList.add('is-active');
        qtyInput.value = 1;
        updatePrice();
        updateImage(radio);
        updateNotice(radio);
      });
    });

    var checkedRadio = document.querySelector('.pc-variant-radio:checked');
    if (checkedRadio) updateNotice(checkedRadio);

    if (minusBtn) {
      minusBtn.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) {
          qtyInput.value = val - 1;
          updatePrice();
        }
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
        updatePrice();
      });
    }
  }

  /* ─── LISTE VOD : AJOUT PANIER AJAX ─── */
  function initVodFilms() {
    var wrapper = document.querySelector('[data-vodf]');
    if (!wrapper) return;

    var LBL_ADDED = wrapper.getAttribute('data-lbl-added') || 'Ajouté';
    var LBL_ERROR = wrapper.getAttribute('data-lbl-error') || 'Erreur';

    wrapper.querySelectorAll('[data-vodf-add]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var id = parseInt(this.getAttribute('data-vodf-add'), 10);
        if (!id || this.disabled) return;
        var self = this;
        var original = self.innerHTML;
        self.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
        .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function() {
          self.classList.add('is-added');
          self.innerHTML = LBL_ADDED;
          /* Mise à jour du compteur panier du header (sélecteurs usuels ; adapter si besoin) */
          fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
            document.querySelectorAll('.cart-count, [data-cart-count], .cart-count-bubble span').forEach(function(el) {
              el.textContent = cart.item_count;
            });
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart, bubbles: true }));
          });
          setTimeout(function() {
            self.classList.remove('is-added');
            self.innerHTML = original;
            self.disabled = false;
          }, 2000);
        })
        .catch(function() {
          self.innerHTML = LBL_ERROR;
          setTimeout(function() { self.innerHTML = original; self.disabled = false; }, 2000);
        });
      });
    });
  }

  /* ─── OVERLAY VIDÉO ─── */
  function initVideo() {
    document.querySelectorAll('[data-extrait-url]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var url = this.getAttribute('data-extrait-url');
        var id = this.getAttribute('data-product-id');
        if (!url || !id) return;
        var overlay = document.getElementById('pc-video-overlay-' + id);
        if (!overlay) return;
        var iframe = overlay.querySelector('[data-video-iframe]');
        if (iframe) iframe.src = url;
        overlay.style.display = 'flex';
        overlay.offsetHeight;
        overlay.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      });
    });
    function closeOv(ov) {
      if (!ov) return;
      ov.classList.remove('is-active');
      document.body.style.overflow = '';
      setTimeout(function() { ov.style.display = 'none'; var f = ov.querySelector('[data-video-iframe]'); if (f) f.src = ''; }, 300);
    }
    document.querySelectorAll('[data-close-video]').forEach(function(b) { b.addEventListener('click', function(e) { e.preventDefault(); closeOv(this.closest('.pc-video-overlay')); }); });
    document.querySelectorAll('[data-video-overlay]').forEach(function(o) { o.addEventListener('click', function(e) { if (e.target === this) closeOv(this); }); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') { var a = document.querySelector('.pc-video-overlay.is-active'); if (a) closeOv(a); } });
  }

  /* ─── OVERLAY GALERIE — SLIDER ─── */
  function initGallery() {
    document.querySelectorAll('[data-gallery-overlay]').forEach(function(overlay) {
      var track = overlay.querySelector('[data-gallery-track]');
      var viewport = overlay.querySelector('[data-gallery-viewport]');
      if (!track || !viewport) return;

      var slides = track.querySelectorAll('.pc-gallery-slide');
      var dots = overlay.querySelectorAll('[data-gallery-dot]');
      var total = slides.length;
      var index = 0;

      function goTo(i) {
        if (i < 0) i = total - 1;
        if (i >= total) i = 0;
        index = i;
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        dots.forEach(function(d, di) {
          d.classList.toggle('is-active', di === index);
        });
      }

      overlay.querySelectorAll('[data-gallery-next]').forEach(function(b) {
        b.addEventListener('click', function(e) { e.stopPropagation(); goTo(index + 1); });
      });
      overlay.querySelectorAll('[data-gallery-prev]').forEach(function(b) {
        b.addEventListener('click', function(e) { e.stopPropagation(); goTo(index - 1); });
      });
      dots.forEach(function(d) {
        d.addEventListener('click', function(e) {
          e.stopPropagation();
          goTo(parseInt(this.getAttribute('data-gallery-dot'), 10));
        });
      });

      /* Swipe tactile — bloque le scroll de la page derrière */
      var startX = 0, startY = 0;
      var isDragging = false;
      var lockedAxis = null; // 'x' ou 'y'

      viewport.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isDragging = true;
        lockedAxis = null;
      }, { passive: true });

      viewport.addEventListener('touchmove', function(e) {
        if (!isDragging) return;
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;

        // Détermine l'axe au premier mouvement franc
        if (!lockedAxis && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
          lockedAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
        // Geste horizontal : on empêche le scroll de la page derrière
        if (lockedAxis === 'x') {
          e.preventDefault();
        }
      }, { passive: false });

      viewport.addEventListener('touchend', function(e) {
        if (!isDragging) return;
        isDragging = false;
        var diff = e.changedTouches[0].clientX - startX;
        if (lockedAxis === 'x' && Math.abs(diff) > 40) {
          if (diff < 0) goTo(index + 1);
          else goTo(index - 1);
        }
        lockedAxis = null;
      }, { passive: false });

      overlay._galleryGoTo = goTo;
    });

    /* Ouverture */
    document.querySelectorAll('[data-gallery-open]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var id = this.getAttribute('data-product-id');
        var overlay = document.getElementById('pc-gallery-overlay-' + id);
        if (!overlay) return;
        if (overlay._galleryGoTo) overlay._galleryGoTo(0);
        overlay.style.display = 'flex';
        overlay.offsetHeight;
        overlay.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      });
    });

    /* Bloque tout touchmove sur l'overlay sauf à l'intérieur du viewport
       (le viewport gère lui-même son swipe). Empêche le scroll du fond. */
    document.querySelectorAll('[data-gallery-overlay]').forEach(function(overlay) {
      overlay.addEventListener('touchmove', function(e) {
        if (!e.target.closest('[data-gallery-viewport]')) {
          e.preventDefault();
        }
      }, { passive: false });
    });

    function closeGallery(ov) {
      if (!ov) return;
      ov.classList.remove('is-active');
      document.body.style.overflow = '';
      setTimeout(function() { ov.style.display = 'none'; }, 300);
    }

    document.querySelectorAll('[data-gallery-close]').forEach(function(b) {
      b.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeGallery(this.closest('.pc-gallery-overlay'));
      });
    });

    document.querySelectorAll('[data-gallery-overlay]').forEach(function(o) {
      o.addEventListener('click', function(e) {
        if (e.target === this || e.target.classList.contains('pc-gallery-viewport')) closeGallery(this);
      });
    });

    document.addEventListener('keydown', function(e) {
      var a = document.querySelector('.pc-gallery-overlay.is-active');
      if (!a) return;
      if (e.key === 'Escape') { closeGallery(a); return; }
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        var activeDot = a.querySelector('.pc-gallery-dot.is-active');
        var cur = activeDot ? parseInt(activeDot.getAttribute('data-gallery-dot'), 10) : 0;
        if (a._galleryGoTo) a._galleryGoTo(e.key === 'ArrowRight' ? cur + 1 : cur - 1);
      }
    });
  }

  /* ─── OPACITÉ TEXTE NON-GRAS ─── */
  function applyTextOpacity() {
    var tabPanels = document.getElementById('pc-tab-panels');
    if (!tabPanels) return;

    var observer = new MutationObserver(function() {
      processActiveTabs();
    });

    observer.observe(tabPanels, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });

    function processActiveTabs() {
      var panels = tabPanels.querySelectorAll('.pc-tab-panel');

      panels.forEach(function(panel) {
        var panelIndex = panel.getAttribute('data-panel-index');
        var tabBtn = document.querySelector('[data-tab-index="' + panelIndex + '"]');
        if (!tabBtn) return;

        var tabTitle = tabBtn.textContent.trim().toLowerCase();

        if (tabTitle === 'détails' || tabTitle === 'details' || tabTitle === 'films') {
          applyOpacityToPanel(panel);
        }
      });
    }

    function applyOpacityToPanel(panel) {
      if (panel.hasAttribute('data-opacity-applied')) return;
      panel.setAttribute('data-opacity-applied', 'true');

      var walker = document.createTreeWalker(
        panel,
        NodeFilter.SHOW_TEXT,
        null,
        false
      );

      var textNodes = [];
      var node;
      while (node = walker.nextNode()) {
        textNodes.push(node);
      }

      textNodes.forEach(function(textNode) {
        var parent = textNode.parentElement;
        if (!parent) return;

        var isBold = false;
        var current = parent;
        while (current && current !== panel) {
          if (current.tagName === 'STRONG' || current.tagName === 'B') {
            isBold = true;
            break;
          }
          var fw = window.getComputedStyle(current).fontWeight;
          var fwNum = parseInt(fw, 10);
          if (fw === 'bold' || fw === 'bolder' || (!isNaN(fwNum) && fwNum >= 500)) {
            isBold = true;
            break;
          }
          current = current.parentElement;
        }

        if (!isBold && textNode.textContent.trim()) {
          var span = document.createElement('span');
          span.style.opacity = '0.4';
          span.textContent = textNode.textContent;
          textNode.parentNode.replaceChild(span, textNode);
        }
      });
    }

    processActiveTabs();
  }

  /* ─── DROITS INSTITUTIONNELS (toggle) ─── */
  function initInstitToggle() {
    var wrapper = document.getElementById('pc-instit');
    var toggle = document.getElementById('pc-instit-toggle');
    if (!wrapper || !toggle) return;

    toggle.addEventListener('click', function() {
      var isOpen = wrapper.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* ─── ALERTE RETOUR EN STOCK (toggle) ─── */
  function initNotifyToggle() {
    var wrapper = document.getElementById('pc-notify');
    var toggle = document.querySelector('[data-notify-toggle]');
    if (!wrapper || !toggle) return;

    toggle.addEventListener('click', function() {
      var isOpen = wrapper.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    // Après soumission native, Shopify recharge la page : on rouvre le panneau si succès
    if (wrapper.querySelector('.pc-notify-success')
        || window.location.search.indexOf('customer_posted=true') !== -1) {
      wrapper.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      wrapper.scrollIntoView({ block: 'center' });
    }
  }

  /* ─── INIT ─── */
  function init() {
    initTabs();
    initBuyControls();
    initVodFilms();
    initVideo();
    initGallery();
    applyTextOpacity();
    initInstitToggle();
    initNotifyToggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();

/* ─── Ajout au panier sans quitter la page ─── */
  (function () {
    var form = document.getElementById('pc-product-form');
    if (!form) return;
    var btn = form.querySelector('.pc-cart-btn');
    var errorEl = form.querySelector('.pc-cart-error');

    form.addEventListener('submit', function (event) {
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (!cart || typeof cart.renderContents !== 'function' || !window.fetch) return; // envoi classique
      event.preventDefault();
      if (btn.getAttribute('aria-disabled') === 'true') return;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('is-loading');
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

      var formData = new FormData(form);
      formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement && cart.setActiveElement(document.activeElement);

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {
            if (errorEl) { errorEl.textContent = response.description || response.message; errorEl.hidden = false; }
            return;
          }
          // Comme product-form.js de Rise : retirer « is-empty » sinon le tiroir ne trouve pas
          // la zone où placer le focus (erreur « getFocusableElements » quand le panier était vide).
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(response);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
          }
        })
        .catch(function () { form.submit(); })
        .finally(function () {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('is-loading');
        });
    });
  })();
